module.exports = __webpack_public_path__ + "img/banner.148c8835.jpg";